var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6855 23.5172V24.8982H0.685547V23.5172L3.46332 20.7553V12.4696C3.46332 8.18863 6.28277 4.41863 10.4078 3.2034C10.4078 3.0653 10.4078 2.94102 10.4078 2.80292C10.4078 2.07042 10.7004 1.36792 11.2214 0.849959C11.7423 0.332001 12.4488 0.0410156 13.1855 0.0410156C13.9223 0.0410156 14.6288 0.332001 15.1497 0.849959C15.6707 1.36792 15.9633 2.07042 15.9633 2.80292C15.9633 2.94102 15.9633 3.0653 15.9633 3.2034C20.0883 4.41863 22.9078 8.18863 22.9078 12.4696V20.7553L25.6855 23.5172ZM15.9633 26.2791C15.9633 27.0116 15.6707 27.7141 15.1497 28.2321C14.6288 28.75 13.9223 29.041 13.1855 29.041C12.4488 29.041 11.7423 28.75 11.2214 28.2321C10.7004 27.7141 10.4078 27.0116 10.4078 26.2791",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.4a2b4d7e9a03c9f720528df72bb57ccf.svg";
export { ForwardRef as ReactComponent };